import React from "react";
import InputFieldContent from "../components/content/InputFieldContent";

const TermsAndCondition = () => {
  return (
    <div className="space-y-5">            
      <InputFieldContent />
    </div>
  );
};

export default TermsAndCondition;
